import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { TrackByHelper } from 'tiime-expert-utils';
import { TiimeButtonModule, TiimeIconModule, TiimeListModule, TiimeTooltipModule } from 'tiime-material';

import { ThreadTag } from '@models/thread-tag';
import { AtByPipe } from '@shared-pipes/at-by/at-by.pipe';

@Component({
  selector: 'app-tags-list',
  standalone: true,
  imports: [TiimeListModule, TiimeButtonModule, TiimeIconModule, TiimeTooltipModule, AtByPipe],
  templateUrl: './tags-list.component.html',
  styleUrl: './tags-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TagsListComponent {
  @Input({ required: true }) tags: ThreadTag[];

  @Output() readonly archiveTag: EventEmitter<ThreadTag> = new EventEmitter<ThreadTag>();
  @Output() readonly unarchiveTag: EventEmitter<ThreadTag> = new EventEmitter<ThreadTag>();

  readonly trackById = TrackByHelper.trackById;

  emitArchiveTag(tag: ThreadTag): void {
    this.archiveTag.emit(tag);
  }

  emitUnarchiveTag(tag: ThreadTag): void {
    this.unarchiveTag.emit(tag);
  }
}
